import { makeStyles } from 'tss-react/mui';
import { themeColors, theme, themeLayout } from 'app/shared/theme';

export const useStyles = makeStyles()({
  switchTrack: {
    height: 20,
    width: 50,
    borderRadius: 10,
  },
  switchBase: {
    opacity: 1,
    height: 16,
    left: 4,
    top: 5,
    '& .Mui-checked': {
      transform: 'translateX(27px)',
    },
  },
  thumb: {
    width: 16,
    height: 16,
  },
  rootSwitch: {
    width: 70,
    marginRight: '-10px',
  },
  toggle: {
    '& .Mui-checked': {
      color: themeColors.white,
      transform: 'translateX(27px)',
    },
  },
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: themeColors.accentDark60,
    overflowY: 'scroll',
    boxSizing: 'border-box',
    position: 'relative',
  },
  container: {
    margin: 'auto',
    [theme.breakpoints.down(themeLayout.breakpointBig)]: {
      width: 500,
    },

    [theme.breakpoints.down(themeLayout.breakpointSmall)]: {
      width: '100%',
    },
    outline: 'none !important',
    position: 'relative',
    backgroundColor: themeColors.white,
  },

  saveButton: {
    display: 'flex',
    justifyContent: 'flex-end',
    padding: '24px',
    alignItems: 'center',
    position: 'absolute',
    bottom: 0,
    height: '86px',
    width: '800px',
    boxSizing: 'border-box',
    zIndex: 200,
    backgroundColor: themeColors.white,
    borderTop: `2px solid ${themeColors.greyscale4}`,

    [theme.breakpoints.down(themeLayout.breakpointBig)]: {
      width: 500,
    },

    [theme.breakpoints.down(themeLayout.breakpointSmall)]: {
      width: '100%',
    },
  },
  body: {
    position: 'absolute',
    width: 800,
    bottom: 86,
    top: 138,
    boxSizing: 'border-box',
    margin: '12px 0px',

    [theme.breakpoints.down(themeLayout.breakpointBig)]: {
      width: 500,
    },

    [theme.breakpoints.down(themeLayout.breakpointSmall)]: {
      width: '100%',
    },

    overflow: 'auto',
    '&::-webkit-scrollbar': {
      width: '5px',
      height: '7px',
      backgroundColor: themeColors.greyscale4,
    },
    '&::-webkit-scrollbar-track': {
      boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
      webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: themeColors.greyscale3,
    },
  },
  deleteButton: {
    padding: '0px 0px 0px 8px',
    cursor: 'pointer',
  },
  nameContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    margin: '-9px 0px',
    whiteSpace: 'nowrap',
  },
  cell: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'left',
    margin: '-9px 0px',
    cursor: 'pointer',
  },
  cellEntity: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'left',
    margin: '-9px 0px',
  },
  label: {
    backgroundColor: themeColors.greyscale4_50,
    borderRadius: 30,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: 30,
    minWidth: 67,
    padding: '0px 12px',
    whiteSpace: 'nowrap',
    marginLeft: 8,
  },
  searchContainer: {
    boxSizing: 'border-box',
    alignSelf: 'center',
    padding: '14px 0px 20px 0px',
    width: '100%',
    borderBottom: `2px solid ${themeColors.greyscale4}`,
  },
  onlySearch: {
    boxSizing: 'border-box',
    alignSelf: 'center',
    padding: '0px 0px 20px 0px',
    width: '100%',
    borderBottom: `2px solid ${themeColors.greyscale4}`,
  },
  textFieldContainer: {
    boxSizing: 'border-box',
    alignSelf: 'center',
    padding: '20px 0px',
    width: '100%',
  },
  textFieldLabel: {
    padding: '0px 16px 3px 16px',
  },
  subheader: {
    padding: '0px 0px 0px 0px',
    width: '100%',
  },
  subheaderWithoutBorder: {
    padding: '10px 0px 0px 0px',
    width: '100%',
  },
  wrapper: {
    height: 78,
    position: 'absolute',
    top: 73,
    width: '100%',
    boxSizing: 'border-box',
    padding: '10px 24px',
  },
  searchWrapper: {
    height: 78,
    position: 'absolute',
    top: 220,
    width: '100%',
    boxSizing: 'border-box',
    padding: '0px 24px',
  },
  withoutPadding: {
    padding: '0px',
  },
  negativeMargin: {
    marginLeft: '-16px',
  },
  plusIcon: {
    cursor: 'pointer',
  },
  actionButtons: {
    minWidth: 'unset',
    padding: '4px 8px',
  },
  select: {
    width: '100%',
  },
  editableDosageTableContainer: {
    width: '100%',
    overflow: 'hidden',
    padding: '0 12px 12px',
    boxSizing: 'border-box',
  },
  editableDosageTableActions: {
    padding: '4px 0 8px',
  },
  editableDosageTable: {
    width: '100%',
    maxWidth: '100%',
    borderCollapse: 'collapse',
    tableLayout: 'fixed',
    '& th, & td': {
      border: `2px solid ${themeColors.greyscale4}`,
      padding: 0,
      textAlign: 'center',
      verticalAlign: 'middle',
      fontSize: 11,
      minWidth: 0,
      height: 38,
      width: 'auto',
      boxSizing: 'border-box',
    },
    '& th:first-child': {
      width: '22%',
      minWidth: 0,
    },
    '& th:not(:first-child)': {
      padding: '4px 2px',
      minWidth: 0,
      width: 'auto',
    },
  },
  editableDosageCorner: {
    position: 'relative',
    height: 38,
    background: `linear-gradient(to top right, transparent 49%, ${themeColors.greyscale4} 50%, transparent 51%)`,
    '& span': {
      position: 'absolute',
      fontSize: 10,
      lineHeight: 1,
      maxWidth: 'calc(100% - 8px)',
      overflowWrap: 'anywhere',
    },
    '& span:first-child': {
      left: 4,
      bottom: 3,
      textAlign: 'left',
      whiteSpace: 'nowrap',
    },
    '& span:last-child': {
      top: 3,
      right: 4,
      textAlign: 'right',
    },
  },
  editableDosageCell: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: 38,
    boxSizing: 'border-box',
    padding: 0,
    margin: 0,
    backgroundColor: themeColors.white,
    '& > div': {
      width: '100%',
      minWidth: 0,
      height: '100%',
      margin: 0,
    },
    '& .MuiFormControl-root, & .MuiInputBase-root, & .MuiOutlinedInput-root': {
      width: '100%',
      minWidth: 0,
      height: 38,
      margin: 0,
      boxSizing: 'border-box',
    },
    '& input': {
      height: 38,
      boxSizing: 'border-box',
      padding: '0 4px',
      textAlign: 'center',
      minWidth: 0,
      lineHeight: '38px',
    },
  },
  editableDosageValueUom: {
    position: 'absolute',
    right: 3,
    top: '50%',
    transform: 'translateY(-50%)',
    fontSize: 10,
    color: themeColors.greyscale2,
    pointerEvents: 'none',
  },
  editableDosageCellButton: {
    width: '100%',
    height: 38,
    border: 0,
    backgroundColor: themeColors.greyscale5,
    cursor: 'pointer',
    font: 'inherit',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    lineHeight: 1,
    '&:hover': {
      backgroundColor: themeColors.highlightBlue,
    },
  },
  editableDosageCellFilled: {
    backgroundColor: themeColors.highlightBlue,
    fontWeight: 700,
  },
  header: {
    width: '800px',
  },
  popover: {
    width: 400,
    boxSizing: 'border-box',
    maxHeight: 300,
    overflowX: 'auto',
    overflowY: 'scroll',
    '&::-webkit-scrollbar': {
      width: '5px',
      height: '5px',
      backgroundColor: themeColors.greyscale4,
    },
    '&::-webkit-scrollbar-track': {
      boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
      webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: themeColors.greyscale3,
    },
  },
});
